import { RouterManager } from '@aclass/admin/managers';
import { OpportunityStory } from '@aclass/admin/storage/actions';
import { IAdminState, IOpportunityModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class OpportunityViewStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:opportunity-view';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IOpportunityModuleState['editPageRecordId']>(['opportunityModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(OpportunityViewStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(OpportunityStory.dryRunEditPage(this.id));
    }
}
